export const CLEAR_POOL_REQUESTS = 'CLEAR_POOL_REQUESTS';

export const clearPoolRequests = () => ({
    type: CLEAR_POOL_REQUESTS,
});
